import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_app-shell/brands/$brandId/edit")({
  beforeLoad: ({ params }) => {
    throw redirect({
      params,
      to: "/brands/$brandId/overview",
    });
  },
  component: () => null,
});
